export const fontSize = string =>
  `${string * process.env.REACT_APP_FONT_MULTIPLIER}rem`;
